/**
 * Basit bildirim gösterme işlevi
 * @param {string} message - Bildirim metni
 * @param {string} type - Bildirim tipi (info, success, error)
 */
const showNotification = (message, type = 'info') => {
  // Bildirim elementini oluştur
  const notification = document.createElement('div');
  notification.className = `notification ${type}`;
  notification.textContent = message;
  document.body.appendChild(notification);
  
  // 3 saniye sonra kaldır
  setTimeout(() => {
    notification.classList.add('fade-out');
    setTimeout(() => {
      document.body.removeChild(notification);
    }, 500);
  }, 3000);
};

export default showNotification; 